import React, { lazy } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Accreditations from '../components/Accreditations';
const AboutPage = () => {
  return <div className="bg-white" data-id="element-388" data-mp="55jzngm6ggc9">
      <Helmet data-id="element-389" data-mp="54iprfgwdzw4">
        <title data-id="element-390" data-mp="548vhfotl6km">
          About Northampton Driving School | Local Driving Instructors
        </title>
        <meta name="description" content="Northampton Driving School specialises in automatic driving lessons. Learn more about our instructors, teaching style, and success rates." data-id="element-391" data-mp="6gw60luii6e" />
        <meta name="keywords" content="driving instructor Northampton, DVSA approved instructor, automatic driving lessons Northampton, driving school Northampton" data-id="element-392" data-mp="3mg1ppxt49vnx" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-393" data-mp="3dflo6tvxoylp">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-394" data-mp="1gjxiu85zk7ly">About Us</h1>
        <h2 className="sr-only" data-id="element-395" data-mp="1blcm4ipy0629">
          DVSA Approved Driving Instructors Northampton
        </h2>
        <h2 className="sr-only" data-id="element-396" data-mp="2evpn4wfp38zy">Qualified Automatic Driving School</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-397" data-mp="2eyk58hb8khq7">
          <div data-id="element-398" data-mp="2jwlqn8w4wt4u">
            <h2 className="text-2xl font-bold mb-4" data-id="element-399" data-mp="2jt7q86716u01">Our Mission</h2>
            <p className="text-gray-700 mb-4" data-id="element-400" data-mp="25wuezet3bou0">
              At <span className="text-burgundy-600" data-id="element-401" data-mp="2aum4y3a6d0vk">N</span>orthampton{' '}
              <span className="text-burgundy-600" data-id="element-402" data-mp="2awqaepnq27xy">D</span>riving{' '}
              <span className="text-burgundy-600" data-id="element-403" data-mp="2ylhwczapxu2a">S</span>chool, we're dedicated
              to providing professional, patient, and reliable driving tuition
              in Northampton. Our mission is to help learners of all abilities
              gain confidence on the road through quality instruction, flexible
              scheduling, and competitive rates.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-404" data-mp="3hiss49x565cz">
              We specialise in automatic car instruction, making the learning
              process smoother and less intimidating for new drivers. Our
              approach focuses on building practical skills and road awareness
              to ensure you become a safe, confident driver for life.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-405" data-mp="3m7lifpi0nxnw">
              Looking for faster results? Check out our{' '}
              <Link to="/intensive-lessons" className="text-burgundy-600 hover:text-burgundy-800 font-medium" aria-label="Learn more about our intensive driving courses" data-id="element-406" data-mp="3h8r1yu7iul6y">
                intensive driving courses Northampton
              </Link>{' '}
              designed to get you test-ready in less time.
            </p>
          </div>
          <div className="rounded-lg overflow-hidden shadow-md" data-id="element-407" data-mp="2yi9dj1tq2bre">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3g4uR3Hsch8qWkEegJDamW/about_us.png" alt="DVSA-approved driving instructor teaching student in automatic car Northampton" className="w-full h-full object-cover" loading="lazy" data-id="element-408" data-mp="2yfwlfvu92l0m" />
          </div>
        </div>
        <div className="mb-12" data-id="element-409" data-mp="190ce0qx3qpco">
          <h2 className="text-2xl font-bold mb-4" data-id="element-410" data-mp="18zas1rejsig6">Our Approach</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-411" data-mp="1dzgm1e8aih1f">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-412" data-mp="1dy5nbstpbzh6">
              <h3 className="text-xl font-semibold mb-3" data-id="element-413" data-mp="1ixqmo4csa9uf">
                Patient Instruction
              </h3>
              <p className="text-gray-700" data-id="element-414" data-mp="lcvvgfzn28yx">
                We understand that learning to drive can be stressful. Our
                instructors are selected for their patience and ability to
                create a calm, supportive learning environment.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-415" data-mp="101s3we5lxo02">
              <h3 className="text-xl font-semibold mb-3" data-id="element-416" data-mp="2lbiunfwib75">
                Personalised Learning
              </h3>
              <p className="text-gray-700" data-id="element-417" data-mp="7j4mp9tqet49">
                Everyone learns differently. We tailor our teaching methods to
                suit your individual learning style and pace, ensuring you make
                steady progress.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-418" data-mp="2iyvgvovqv1ny">
              <h3 className="text-xl font-semibold mb-3" data-id="element-419" data-mp="2j0g7x4iuo2h2">
                Comprehensive Training
              </h3>
              <p className="text-gray-700" data-id="element-420" data-mp="2e62ayxojhnaa">
                Beyond just passing the test, we focus on developing safe
                driving habits and road awareness that will serve you throughout
                your driving life.
              </p>
            </div>
          </div>
        </div>
        <div className="mb-12" data-id="element-421" data-mp="31vn58cq586yv">
          <h2 className="text-2xl font-bold mb-4" data-id="element-422" data-mp="2wywgz246q52d">Our Instructors</h2>
          <p className="text-gray-700 mb-6" data-id="element-423" data-mp="2wwjxgkis3mn7">
            Our instructors are DVSA approved and hold Approved Driving
            Instructor (ADI) qualifications. They undergo regular training to
            stay updated with the latest teaching methods and driving standards.
          </p>
        </div>
        <Accreditations data-id="element-424" data-mp="3eabeftzto11c" />
        <div className="mt-12 text-center" data-id="element-425" data-mp="3j6sbjdp01pqk">
          <h2 className="text-2xl font-bold mb-4" data-id="element-426" data-mp="3j6k2jwvzz4kn">
            Start Your Journey With Us
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-427" data-mp="35fewod21dg1v">
            Whether you're a complete beginner or looking to polish your skills
            before your test, we're here to help you become a confident, safe
            driver.
          </p>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your first driving lesson in Northampton" data-id="element-428" data-mp="30h3p68z7rhmt">
            Book Your First Lesson
          </a>
        </div>
      </div>
    </div>;
};
export default AboutPage;